import { HttpForm } from "../Support/HttpForm";
export class Report extends HttpForm {
    selected = false;
    section = 'index';
    app;
    constructor(app) {
        super();
        this.app = app;
    }
    selectSection(section) {
        this.section = section;
    }
    sectionIs(section) {
        return this.section === section;
    }
    showReport(payload) {
        this.selectSection('render');
        this.selected = payload;
    }
    isAdminUser() {
        if (this.app && this.app.auth) {
            return this.app.auth.role === 'admin';
        }
        return false;
    }
}
